export default __webpack_public_path__ + "static/media/logo.cb900f95.png";